import { Injectable, signal } from '@angular/core';
import { ItemScan } from '@softline/application';
import { InventoryProduct } from '../types/inventory-product';

@Injectable()
export class AddInventoryService {
  readonly selectedProduct = signal<InventoryProduct | null>(null);
  /** Set by a scan, cleared once the add form has the scanned article; both pages show the scan animation meanwhile. */
  readonly scanInProgress = signal(false);

  showScanProgress(): void {
    this.scanInProgress.set(true);
  }

  hideScanProgress(): void {
    this.scanInProgress.set(false);
  }

  selectScan(scan: ItemScan): void {
    this.selectedProduct.set({
      id: scan.artikel.id,
      artikelnummer: scan.artikel.nummer,
      artbez1: scan.artikel.artbez1,
      artbez2: scan.artikel.artbez2,
      artbez3: scan.artikel.artbez3,
      artbez4: scan.artikel.artbez4,
      artbez5: scan.artikel.artbez5,
      eannummer: scan.ean,
      isManartikel: !!scan.manartikel,
    });
  }
}
